import React from 'react';
import { Dialog } from '@/components/ui/dialog';
import { Keyboard } from 'lucide-react';

export default function ShortcutsDialog({ open, onClose }) {
  return (
    <Dialog open={open} onClose={onClose}>
      <div className="p-6 max-w-md w-full bg-slate-900 text-white rounded-lg shadow-xl">
        <div className="flex items-center gap-3 mb-4">
          <Keyboard className="h-6 w-6 text-blue-400" />
          <h2 className="text-xl font-bold text-blue-300">Keyboard Shortcuts</h2>
        </div>
        <ul className="space-y-3">
          <li><kbd className="kbd bg-slate-800 text-blue-200 px-2 py-1 rounded">Space</kbd> — Play/Pause</li>
          <li><kbd className="kbd bg-slate-800 text-blue-200 px-2 py-1 rounded">M</kbd> — Toggle Streamer/Default Mode</li>
          <li><kbd className="kbd bg-slate-800 text-blue-200 px-2 py-1 rounded">Tab</kbd> — Toggle Playlist Visibility</li>
          <li><kbd className="kbd bg-slate-800 text-blue-200 px-2 py-1 rounded">←</kbd> — Previous Track</li>
          <li><kbd className="kbd bg-slate-800 text-blue-200 px-2 py-1 rounded">→</kbd> — Next Track</li>
          <li><kbd className="kbd bg-slate-800 text-blue-200 px-2 py-1 rounded">P</kbd> — Maximize/Minimize Player</li>
        </ul>
        <div className="mt-6 flex justify-end">
          <button onClick={onClose} className="px-4 py-2 rounded bg-blue-500 text-white hover:bg-blue-600 font-semibold">Close</button>
        </div>
      </div>
    </Dialog>
  );
}
